import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './bizconnect.component.scss';
var Bizconnect = /** @class */ (function (_super) {
    tslib_1.__extends(Bizconnect, _super);
    function Bizconnect(element) {
        return _super.call(this, element) || this;
    }
    Bizconnect.prototype.init = function () { };
    Bizconnect.prototype.bindEvents = function () { };
    return Bizconnect;
}(Base));
export { Bizconnect };



//////////////////
// WEBPACK FOOTER
// ./components/bizconnect/bizconnect.component.ts
// module id = 148
// module chunks = 0